






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Attribute } from '@/interfaces/Attribute';
import { AttributeHasEnvironment } from '@/interfaces/AttributeHasEnvironment';
import { Environment } from '@/interfaces/Environment';

@Component({})
export default class StepEnvironmentInput extends Vue {
  selectedEnvironment: number | null = null;

  @Prop()
  environments!: Environment[];

  set selectedEnvironmentValue(value: string) {
    if (!this.selectedEnvironment) {
      this.attribute.value_txt = value;
      return;
    }
    let environment = this.attribute.environments.find(
      ({ environment_id }) => environment_id === this.selectedEnvironment
    );

    if (!environment) {
      environment = {
        environment_id: this.selectedEnvironment,
        attribute_id: this.attribute.id,
        value_txt: null
      } as AttributeHasEnvironment;
      this.attribute.environments.push(environment);
    }

    environment.value_txt = value;
  }

  get selectedEnvironmentValue(): string {
    if (!this.selectedEnvironment) {
      return this.attribute.value_txt || '';
    }
    let environment = this.attribute.environments?.find(
      ({ environment_id }) => environment_id === this.selectedEnvironment
    );

    if (!environment) {
      environment = {
        environment_id: this.selectedEnvironment,
        attribute_id: this.attribute.id,
        value_txt: null
      } as AttributeHasEnvironment;
      this.attribute.environments.push(environment);
    }
    return environment.value_txt || '';
  }

  get selectedEnvironmentColor(): string {
    return (
      this.$store.state.all_environments.find((e: Environment) => e.id === this.selectedEnvironment)
        ?.color || '#FFFFFF'
    );
  }

  @Prop()
  attribute!: Attribute;

  @Prop()
  parentAttribute!: Attribute;

  @Prop()
  globalSelectedEnvironment?: number;

  @Watch('globalSelectedEnvironment')
  watchGlobalSelectedEnvironment(value: number) {
    this.selectedEnvironment = value || null;
  }

  created() {
    this.selectedEnvironment = this.globalSelectedEnvironment || null;
  }
}
